import { Formik } from 'formik'
import React from 'react'
import { UseMutatePositionByIdReturn, positionDetailsByIdDocument, useMutatePositionById, usePositionDetailsById } from 'src/queries'
import Form from './Form'
import { useInvalidateQueryByDocument } from 'src/hooks/useGraphQL'
import useLookups from 'src/pages/cat/positions/Position/cards/Details/EditModal/useLookups'
import { MutatePositionByIdMutation } from 'src/gql/graphql'
import { emptyStringToNull } from 'src/helpers/formHelpers'
import { pick } from 'lodash'
import * as Yup from 'yup'

export type Values = Parameters<UseMutatePositionByIdReturn['mutate']>[0]['record']

interface FormContextProps {
  id: number
  toggle: () => void
}

const FormContext: React.FC<FormContextProps> = (props) => {
  const { id, toggle } = props
  const position = usePositionDetailsById(id)
  if (position === undefined) {
    throw new Error('Could not load position!')
  }
  const lookups = useLookups()
  const update = useMutatePositionById()
  const initialState: Values = pick(position, [
    'backfill',
    'numberOfOpenings',
    'closed_date',
    'contract',
    'contract_type',
    'direct_hire',
    'exemptStatus',
    'filled_date',
    'hiring_manager',
    'keywords',
    'workSetting',
    'location',
    'priority',
    'program_manager',
    'required_clearance',
    'status',
    'temp_to_perm',
    'title'
  ])
  const invalidatePosition = useInvalidateQueryByDocument(positionDetailsByIdDocument)
  const handleSuccess = (data: MutatePositionByIdMutation): void => {
    const id = data.cat?.position?.updateById?.recordId
    if (typeof id === 'number') {
      void invalidatePosition({ id })
    }
    toggle()
  }
  const validationSchema = Yup.object().shape({
    title: Yup.string().required().label('Title'),
    // eslint-disable-next-line no-template-curly-in-string
    numberOfOpenings: Yup.number().required('${label} is required.').min(1).positive('${label} must be a number greater than 0.').integer('${label} must be a whole number.').label('Number of Openings'),
    workSetting: Yup.string().required().label('Work Setting')
  })
  return (
    <Formik
      initialValues={initialState}
      onSubmit={async (data) => {
        const record = { ...data }
        emptyStringToNull(record, 'contract')
        emptyStringToNull(record, 'status')
        emptyStringToNull(record, 'exemptStatus')
        emptyStringToNull(record, 'contract_type')
        emptyStringToNull(record, 'priority')
        emptyStringToNull(record, 'program_manager')
        emptyStringToNull(record, 'hiring_manager')
        emptyStringToNull(record, 'required_clearance')
        emptyStringToNull(record, 'workSetting')

        update.mutate({ id, record }, { onSuccess: handleSuccess })
      }}
      validationSchema={validationSchema}
    >
      {(props) => (
        <Form lookups={lookups} toggle={toggle} isLoading={update.isLoading} hasError={update.isError} />
      )}
    </Formik>
  )
}

export default FormContext
